import React from 'react'
import clsx from 'clsx'
import { ReactComponent as IconUser } from 'images/user.svg';
import { ReactComponent as IconShield } from 'images/shield-10.svg';
import styles from './Avatar.module.scss';

type AvatarProps = {
  image?: string,
  username?: string,
  className?: string,
  isExpert?: boolean
  onClick?: () => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

function Avatar({
  image = '',
  username = '',
  className = '',
  isExpert,
  onClick,
  onChange,
}: AvatarProps) {
  return (
    <div className={clsx(className, styles.avatarContainer)} onClick={onClick} onChange={onChange}>
      {image ? (
        <>
          <img src={image} alt={username} />
          {isExpert && <div className={styles.svg}><IconShield /></div>}
        </>
      ) : (
        <IconUser className={styles.avatarDefault} />
      )}
    </div>
  )
}

export default Avatar
